import React, {useEffect, useState} from 'react'
import '../assets/css/Panel.css'
import Navbar from "../components/Navbar";
import {useNavigate} from "react-router-dom";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import {useDisclosure} from "@chakra-ui/react";
import {DeleteExamModal, ExamModal} from "../components/ExamModal";
import AdminExamCard from "../components/adminExamCard";
import Loader from "../components/Loader";

function Exams() {
    const navigate = useNavigate();
    const [exams, setExams] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [refresh, setRefresh] = useState(true);
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {isOpen: isOpenDelete, onOpen: onOpenDelete, onClose: onCloseDelete } = useDisclosure()
    const [selectedExam, setSelectedExam] = useState(null);
    const [loading,setLoading] = useState(false);
    const openModal = (exam) => {
        setSelectedExam(exam);
        onOpen();
    };
    const openDeleteModal = (exam) => {
        setSelectedExam(exam);
        onOpenDelete();
    };
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/exam')
                setExams(response.data.data);
                setCurrentPage(response.data.current_page)
                setLastPage(response.data.last_page)

            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
                setRefresh(false);
            }
        }
        if (refresh)
            fetchData();
    }, [currentPage, refresh]);

    const handleNextPage = () => {
        if (currentPage < lastPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <>
            <div className="d-flex flex-column h-100">
                <Navbar/>
                <div className="cards-container row pt-3 justify-content-center">
                    <AdminExamCard onClickCard={() => {
                        openModal(null)
                    }} newExam={true}/>
                    {exams.map((exam) => (
                        <AdminExamCard navigator={navigate} exam={exam} onClickCard={() => openModal(exam)}
                                       onDeleteClick={() => {
                                           openDeleteModal(exam)
                                       }}/>
                    ))}
                </div>
                <div className="py-2 d-flex justify-content-center gap-3">
                    <button
                        className={`btn btn-outline-orange`}
                        disabled={1 === currentPage}
                        onClick={() => {
                            setCurrentPage(1)
                        }}
                    >
                        صفحه اول
                    </button>
                    <button
                        className={`btn btn-outline-blue`}
                        disabled={currentPage === 1}
                        onClick={handlePrevPage}
                    >
                        صفحه قبل
                    </button>
                    <button
                        className={`btn btn-outline-blue`}
                        disabled={lastPage === currentPage}
                        onClick={handleNextPage}
                    >
                        صفحه بعد
                    </button>
                    <button
                        className={`btn btn-outline-orange`}
                        disabled={lastPage === currentPage}
                        onClick={() => {
                            setCurrentPage(lastPage)
                        }}
                    >
                        صفحه آخر
                    </button>
                </div>
            </div>
            <ExamModal isOpen={isOpen} onClose={onClose} setRefresh={setRefresh} exam={selectedExam}/>
            <DeleteExamModal isOpen={isOpenDelete} onCloseDelete={onCloseDelete} setRefresh={setRefresh}
                             exam={selectedExam}/>
        </>
    );
}

export default Exams;
